import React, { useEffect, useState } from "react";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import View from "components/presentation/start/stats/CollaborationStats.view";


function CollaborationStats({ user }) {

  const [callCollaboratorStats, reqCollaboratorStats] = usePost("/flows/get_top_collaborators_stats")

  useEffect(() => {
    callCollaboratorStats({ user_id: user.id, top_n: 7 })
  }, []);


  if (reqCollaboratorStats.loading) return <PlaceholderView />;
  if (reqCollaboratorStats.error) return ""
  const collaboratorStats = reqCollaboratorStats.data;

  return (
    <View
      user={user}
      collaboratorStats={collaboratorStats}
    />
  );
}

const PlaceholderView = () =>
  <div id="start-activity" className="card">
    <div id="start-activity-container" class="card-body position-relative my-5">
      <Loading size={35} />
    </div>
  </div>


export default CollaborationStats;